<app-payment-animated-states
  [state]="paymentState"
></app-payment-animated-states>
<app-payment-iframe></app-payment-iframe>
